<script setup lang="ts">
import type { InvestigationChapterCollectionItem, InvestigationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  article?: InvestigationCollectionItem
  chapters: InvestigationChapterCollectionItem[]
}>()
</script>

<template>
  <ApplicationLayoutSplitContent class="relative">
    <ApplicationLayoutSplitContentColumnLeft v-if="chapters">
      <div class="sticky top-20 p-4  lg:ml-auto lg:w-80">
        <h2 class="mb-4 text-center font-heading text-2xl text-primary-700 dark:text-neutral-300">
          Hoofdstukken
        </h2>
        <div class="flex flex-col gap-4">
          <InvestigationArticleChaptersChapter
            v-for="chapter in props.chapters" :key="chapter.path" :chapter="chapter"
          />
        </div>
      </div>
    </ApplicationLayoutSplitContentColumnLeft>
    <ApplicationLayoutSplitContentColumnRight>
      <NuxtPage :article="props.article" />
    </ApplicationLayoutSplitContentColumnRight>
  </ApplicationLayoutSplitContent>
</template>
